import { insertText, setNodes, withoutNormalizing } from '@udecode/plate';
import { NodeEntry } from 'slate';
import { withoutLosingSelection } from '~/editor/helpers/withoutLosingSelection';
import { LinkElement } from '../nodes/LinkElement';

export const toggleShortening = (
  editor,
  [node, path]: NodeEntry<LinkElement>
) => {
  withoutLosingSelection(editor, () => {
    withoutNormalizing(editor, () => {
      const newNode = {
        ...node,
        isShortened: node.shortUrl ? !node.isShortened : false,
      };
      setNodes(editor, newNode, { at: path });
      insertText(editor, LinkElement.getText(newNode), {
        at: path,
      });
    });
  });
};
